<template>
    <div class="head-db">
        <div class="topimg">
          <img src="../../images/zyy/topbg.png" alt="">
        </div>
        <div class="topnav w1200">
          <ul class="ub ub-xc ub-ab bul">
            <li :class="cur==0?'cur bli':'bli'" ><a href="/">医院首页</a></li>
            <li :class="item.cur==1?'cur bli':'bli'" v-for="(item, index) in navList" :key="index"  >
              <a @click="active(index,0,0)">
                {{item.name}} </a>
                <ul class="smul" v-if="item.child">
                  <li v-for="(item1, index1) in item.child" :key="index1" > <a @click="active(index1,1,index)">
                    {{item1.name}} </a></li>
                </ul>

            </li>
          </ul>
        </div>
        <div class="code">
            <ul>
              <li>
                <img src="../../images/zyy/code2.png" alt="">
                <p>手机网站二维码</p>
              </li>
              <li>
                <img src="../../images/zyy/code1.png" alt="">
                <p>微信公众号</p>
              </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'tHead',
        data() {
            return {
                navList: [],
                id:this.$route.query.id,
                url:this.$route.path,
                aid:this.$route.query.aid,
                cur:0,
              mobileSite:'',
              zyyWxQrCode:'',
            }
        },
        mounted: function () {
            this.initData();
        },
        methods: {
          initData: async function () {
            let res = await this.$getJSON('zyyindex/channelList',{id:this.id,url:this.url,aid: this.aid});
            if (res.code == 1) {
              this.navList = res.data.navlist;
              this.cur=res.data.cur;
              this.zyyWxQrCode=res.data.zyyWxQrCode;
              this.mobileSite=res.data.mobileSite;
              if(this.url=="/"){
                this.cur=0;
              }
            }
          },
          active: function (e,c,index) {
            // this.$store.commit('SUBNAVZYY', 0);
            // // this.currentactive = e;
            // this.$store.commit('NAVZYY', e);
            if(e == -1){
              this.$router.push({path:'/'});
            }else{
              if(c==0){
                this.$router.push({path:this.navList[e]['channel_url']});
              }else{
                let list=this.navList[index]['child'];
                let channelInfo=list[e];
                if(this.getURL(channelInfo['channel_url'])){
                  window.location.href=channelInfo['channel_url'];
                }else{
                  //window.location.href=list[e]['channel_url'];
                  this.$router.push({path:list[e]['channel_url']});

                }

              }
            }

          },
          getURL(url){
            //如果为真则为外链
            let strURL = false;
            if(url.substr(0,7).toLowerCase() == "http://" || url.substr(0,8).toLowerCase() == "https://"){
              strURL = true;
            }else{
              strURL = false;
            }
            return strURL;
          }
        }
    }
</script>

<style lang="scss">
  .head-db{
    .topimg{
      width: 1200px;
      margin: 0 auto;
    }
    .topnav{
      background: url("../../images/zyy/navbg.png") no-repeat;
      background-size: 100%;
      height: 50px;
      .bul{
        padding: 7px 11px;
        .bli{
          float: left;
          position: relative;
          a{
            display: block;
            width: 106px;
            height: 38px;
            line-height: 38px;
            text-align: center;
            color: #fff;
            font-size: 18px;
          }
          &.cur{
            >a{
              background: url("../../images/zyy/navselbg.png") no-repeat;
              background-size: 100%;
            }
          }
          &:hover{
            >a{
              background: url("../../images/zyy/navselbg.png") no-repeat;
              background-size: 100%;
            }
            .smul{
              display: block;
            }
          }
          .smul{
            position: absolute;
            top: 100%;
            left: 0;

            display: none;
            padding-top: 5px;
            z-index: 99999999999;
            li{
              background: #0084b9;
              a{
                font-size: 16px;
              }
              &:hover{
                background: #016992;
              }
            }
          }
        }
      }
    }
    .code{
      position: fixed;
      top: 285px;
      right: 2%;
      z-index: 99999999999999999999;
      li{
        background: #fff;
        margin-bottom: 8px;
        text-align: center;
        padding: 10px;
        width: 125px;
        img{
          width: 100%;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/layout/head.vue